import { LoadExtract } from "../../domain/use-case/LoadExtract"
import api from "../../services/api"

interface ExtractDetailsProps {
  userId: string
  parentOrderId: number
  catalogId: number
}

export class RemoteLoadExtractDetails {
  async handle (params: ExtractDetailsProps): Promise<LoadExtract.Result> {
    const response = await api.get(`/order/details/${params.userId}/${params.parentOrderId}?catalogId=${params.catalogId}`)
    return response.data
  }
}